module.exports={
    "over_size_message":"Η εικόνα που ανεβάσατε είναι πάνω από 10MB. Θα συμπιέσουμε το αρχείο σας για μεταφόρτωση. Κάντε κλικ στο \"Επιβεβαίωση\" για να συνεχίσετε τη μεταφόρτωση.",
    "file_type_error":"Το αρχείο που ανεβάσατε δεν είναι εικόνα! Προσπαθήστε να ανεβάσετε ξανά.",
    "upload_error":"Σφάλμα μεταφόρτωσης! (Κωδικός σφάλματος: 2000) Δοκιμάστε ξανά.",
    "watermark_remove_over_size":"Η εικόνα που ανεβάσατε είναι πάνω από 5MB. Συνιστάται να χρησιμοποιείτε τον Δωρεάν διαδικτυακό συμπιεστή εικόνων μας. Κάντε κλικ για <a class=\"jump-link\" href=\"https://www.anymp4.com/el/image-compressor-online/\">μάθετε περισσότερα</a>",
    "watermark_remove_file_type_error":"Το αρχείο που ανεβάσατε δεν είναι εικόνα, μεταφορτώστε ξανά.",
    "watermark_remove_image_type_error":"Η μορφή εικόνας δεν υποστηρίζεται. Υποστηρίζουμε μόνο JPG, JPEG, PNG και BMP.",
    "watermark_remove_upload_error":"Σφάλμα αναγνώρισης (κωδικός σφάλματος: 2001), δοκιμάστε ξανά...",
    "watermark_remove_processing":"Επεξεργασία εικόνας...",
    "watermark_remove_not_save":"Η περιοχή που επιλέξατε δεν θα διατηρηθεί. Είστε βέβαιοι ότι θέλετε να το περικόψετε;",
    "watermark_remove_back_home":"Η τρέχουσα κατάσταση δεν θα αποθηκευτεί. Είστε βέβαιοι ότι θέλετε να επιστρέψετε στο σπίτι;",
    "watermark_remove_new_image":"Η τρέχουσα κατάσταση δεν θα αποθηκευτεί. Είστε βέβαιοι ότι θέλετε να επιλέξετε μια νέα εικόνα;",
    "watermark_select":"Επιλέγω",
    "watermark_select_area":"Επιλέξτε την περιοχή του υδατογραφήματος που θέλετε να διαγράψετε πριν κάνετε κλικ στην επιλογή Κατάργηση.",
    "watermark_beyond_12k":"Η επιλεγμένη εικόνα υπερβαίνει τα 12K ανάλυση. Λυπούμαστε που δεν μπορούμε να το επεξεργαστούμε αυτήν τη στιγμή",
    "watermark_beyond_pixel_1":"Η επιλεγμένη ανάλυση εικόνας υπερβαίνει το <span>%spx</span><span>&times;%spx</span>. Δεν είναι δυνατή η επεξεργασία του, επιλέξτε ξανά.",
    "watermark_beyond_pixel_2":"Οι επισκέπτες μπορούν να επεξεργαστούν μόνο <span>%s</span> εικόνες με ανάλυση πάνω από <span>%spx</span>x<span>%spx</span>, συνδεθείτε και συνεχίστε να χρησιμοποιείτε.",
    "watermark_beyond_size_1":"Το επιλεγμένο μέγεθος εικόνας υπερβαίνει τα <span>%sMB</span>. Δεν είναι δυνατή η επεξεργασία του, επιλέξτε ξανά.",
    "watermark_beyond_size_2":"Το επιλεγμένο μέγεθος εικόνας υπερβαίνει τα <span>%sMB</span>, αλλά οι επισκέπτες μπορούν να επεξεργαστούν μόνο εικόνες μικρότερες από <span>%sMB</span>. Παρακαλούμε συνδεθείτε και συνεχίστε να χρησιμοποιείτε.",
    "no_user_down":"Οι επισκέπτες μπορούν να κατεβάσουν εικόνες <span>%s</span> μόνο με αρχική ποιότητα. Παρακαλούμε συνδεθείτε και συνεχίστε τη λήψη. Επίσης, μπορείτε να διατηρήσετε το ιστορικό 7 ημερών μετά τη σύνδεση. Συνεχίστε τη λήψη εικόνων με πλάτος ή υψηλό <span>%spx</span>.",
    "no_down_rights":"Δεν είναι δυνατή η λήψη εικόνων HD με αρχική ποιότητα, αναβαθμίστε το σχέδιό σας! Μπορείτε επίσης να συνεχίσετε τη λήψη εικόνων χαμηλής ποιότητας με το <span>%spx</span>.",
    "error_40001":"Σφάλμα: 40001. Επικοινωνήστε μαζί μας",
    "error_40099":"Σφάλμα: 40099. Επικοινωνήστε μαζί μας",
    "down_btn":"Η λήψη είναι σε προετοιμασία, περιμένετε για ένα δευτερόλεπτο...",
    "noRemove_down_btn":"Δεν έχετε κάνει τίποτα για την αφαίρεση υδατογραφημάτων. Επιλέξτε το υδατογράφημα που θέλετε να αφαιρέσετε και κάντε κλικ στο κουμπί Κατάργηση. Στη συνέχεια, μπορείτε να κάνετε λήψη της εικόνας σας.",
    "history_open":"Ανοίγοντας την τροποποιημένη εικόνα, περιμένετε λίγο...",
    "maskRightsMonitor_info":"Η σελίδα για την αναβάθμιση των παροχών έχει ανοίξει σε νέα καρτέλα και το σχέδιό σας θα συγχρονιστεί αυτόματα μετά την αναβάθμιση.",
    "maskLoginMonitor_info":"Η σελίδα προορισμού έχει ανοίξει, συμπληρώστε τη σύνδεση σε αυτήν. Αφού συνδεθείτε ή εγγραφείτε με επιτυχία, αυτή η σελίδα θα συγχρονιστεί αυτόματα, μην την κλείσετε.",
    "photo_rights_info":"Μπορείτε να κάνετε λήψη <span><i class=\"num\">2</i> εικόνων HD</span> με αρχική ποιότητα προς το παρόν. <a href=\"https://account.anymp4.com\" target=\"_blank\">Προβολή λεπτομερειών>></a>",
    "rights_original":"Για να ενεργοποιήσετε τη ρύθμιση \"Χρήση της λειτουργίας Βελτιωτή εικόνας για μείωση της απώλειας ποιότητας\", πρέπει να αναβαθμίσετε τον λογαριασμό σας!",
    "Brush":"Βούρτσα",
    "Lasso":"Λάσο",
    "Polygonal":"Πολυγωνικό",
    "Eraser":"Γόμα",
    "Free":"Ελεύθερος",
    "More":"Περισσότερο:",
    "Select":"Επιλέγω",
    "Remove":"Αφαιρώ",
    "BrushSize":"Μέγεθος βούρτσας:",
    "AspectRatio":"Αναλογία απεικόνισης:",
    "Upload":"ΝΕΑ ΦΩΤΟΓΡΑΦΙΑ",
    "History":"Ιστορία",
    "Login":"Σύνδεση",
    "MyAccount":"Ο λογαριασμός μου",
    "Logout":"Αποσύνδεση",
    "Usinghelp":"Χρήση βοήθειας>>",
    "Enhancer":"Χρησιμοποιήστε τη λειτουργία Image Enhancer για να μειώσετε την απώλεια ποιότητας",
    "Download":"Κατεβάστε",
    "Guide":"Οδηγός",
    "Polygonal1":"Πολυγωνικό",
    "Polygonal_info":"Κάντε κλικ στο αριστερό κουμπί του ποντικιού για να προσδιορίσετε ένα σημείο κάθε φορά.",
    "Lasso1":"Λάσο:",
    "Lasso_info":"Πατήστε παρατεταμένα το αριστερό κουμπί του ποντικιού για να κάνετε λάσο στην περιοχή του υδατογραφήματος.",
    "Brush1":"Βούρτσα:",
    "Brush_info":"Πατήστε παρατεταμένα το αριστερό κουμπί του ποντικιού για να επιλέξετε με ακρίβεια.",
    "Eraser1":"Γόμα:",
    "Eraser_info":"Διαγράψτε τα περιττά μέρη από την επιλεγμένη περιοχή.",
    "Click":"Κάντε κλικ",
    "the":"ο",
    "click_info":"κουμπί για να αρχίσει να σβήνει το ανεπιθύμητο υδατογράφημα.",
    "PleaseUploadImages":"Παρακαλώ ανεβάστε εικόνες.",
    "CropInfo":"Μόλις ολοκληρωθεί η αφαίρεση του υδατογραφήματος, μπορείτε να κάνετε κλικ στο κουμπί Περικοπή για να περικόψετε την εικόνα σας πριν την αποθήκευση ή κάντε κλικ στο κουμπί Λήψη για να αποθηκεύσετε απευθείας την τρέχουσα εικόνα.",
    "Crop":"Καλλιέργεια",
    "Back":"Πίσω",
    "DownloadCropped":"Λήψη Περικομμένο",
    "Cancel":"Ματαίωση",
    "FreeWatermarkRemover":"Δωρεάν αφαίρεση υδατογραφημάτων",
    "Processing":"Επεξεργασία...",
    "NewImage":"Νέα εικόνα",
    "Retry":"Ξαναδοκιμάσετε",
    "Yes":"Ναί",
    "No":"Οχι",
    "FailureFeedback":"Ανατροφοδότηση αποτυχίας",
    "removeTip":"Αφού επιλέξετε την περιοχή υδατογραφήματος, κάντε κλικ στην Κατάργηση για να διαγράψετε το υδατογράφημα.",
    "rightDown":"Λήψη εικόνων χαμηλής ποιότητας",
    "history_will":"Θα λήξει μετά",
    "Expired":"(Εχει λήξει)",
	"uploadImage":"Μεταφόρτωση",
    "uploadImageInfo":"Ή αποθέστε το αρχείο εικόνας σας εδώ για να αφαιρέσετε το υδατογράφημα!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Απεριόριστος",
    "watermark_beyond_pixel_3":"Η επιλεγμένη εικόνα υπερβαίνει την <span>%s&times;%s ανάλυση</span>, αναβαθμίστε πρώτα το σχέδιό σας.",
    "watermark_beyond_size_3":"Η επιλεγμένη εικόνα υπερβαίνει τα <span>%sMB</span>, αναβαθμίστε πρώτα το σχέδιό σας.",
    "no_user_login":"Οι νέοι χρήστες που συνδέονται μπορούν να αποκτήσουν πλεονεκτήματα λήψης πρωτότυπων εικόνων ΔΥΟ HD.<span class=\"loginMaskbtn\">Σύνδεση αμέσως>></span>",
    "Upgrade":"Αναβαθμίζω",
    "Loading":"Φόρτωση…",
    "SelectAll":"Επιλογή όλων",
    "Open":"Ανοιξε",
    "Delete":"Διαγράφω",
    "Clear":"Διαγραφή μη έγκυρου",
    "noHistory":"Χωρίς Ιστορία",
    "Close":"Κλείσε",
    "buyUserInfo":"συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Επιστρέψτε στην αρχική σελίδα και χρησιμοποιήστε αυτό το προϊόν.",
    "buyNoUserInfo":"Συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Τα πλεονεκτήματα έχουν δεσμευτεί στη διεύθυνση ηλεκτρονικού ταχυδρομείου που αφήσατε κατά την αναβάθμιση. Χρησιμοποιήστε τον λογαριασμό που είναι καταχωρημένος ή συνδεδεμένος με τη διεύθυνση ηλεκτρονικού ταχυδρομείου για να <span class=\"loginMaskbtn\">συνδεθείτε για να χρησιμοποιήσετε τα οφέλη</span>. Εάν δεν έχετε εγγραφεί ή δεν έχετε συνδέσει λογαριασμό με τη διεύθυνση ηλεκτρονικού ταχυδρομείου, <span class=\"registerMaskbtn\">χρησιμοποιήστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου για να καταχωρίσετε έναν λογαριασμό</span> ή συνδέστε άλλους λογαριασμούς σε αυτό το e- διεύθυνση αλληλογραφίας για τη χρήση παροχών.",
    "GetStarted":"Ξεκίνα",
    "AccessTo":"Πρόσβαση σε:",
    "imagesOfwatermarkremoval":"εικόνες αφαίρεσης υδατογραφήματος",
    "upTo":"Μέχρι και",
    "perImage":"ανά εικόνα",
    "Support":"Υποστήριξη",
    "resolution":"ανάλυση",
    "PrepaidPackage":"Προπληρωμένο Πακέτο",
    "PayasYouGo":"Pay as You Go",
    "TaxIncl":"Φόρος συμπερ.",
    "Checkout":"Ολοκλήρωση αγοράς",
    "imagesDay":"εικόνες/ημέρα",
    "imagesMonthly":"εικόνες/μηνιαίο",
    "image":"εικόνα",
    "images":"εικόνες",
    "imageSize":"μέγεθος εικόνας",
    "buyInfo1":"Ενσωματώσεις <span>βελτιωτή</span> τρίτου μέρους",
    "buyInfo2":"Το ιστορικό επεξεργασίας ισχύει για 7 ημέρες",
    "buyInfo3":"Επεξεργασία κατά προτεραιότητα",
    "buyInfo4":"Υποστήριξη πελατών 7x24",
    "buyInfo5":"Λήγει μετά από 24 ώρες",
    "buyInfo6":"Χωρίς συνδρομή. Χωρίς αυτόματη ανανέωση!",
    "buyInfo7":"Διαθέσιμο για χρήση οποιαδήποτε στιγμή για πάντα",
    "dayPlan":"Πρόγραμμα 1 ημέρας",
    "Lifetime":"Διάρκεια Ζωής",
}